import { Checkbox } from "@mui/material";
import { useMemo } from "react";
import { flushSync } from "react-dom";

type Props = {
  config: any;
  setConfig: (v: any) => void;
  selectedTab: number;
  label: string;
  options: any[];
};

const ModificationSelection = ({
  label,
  options,
  config,
  setConfig,
  selectedTab,
}: Props) => {
  const selected = useMemo(
    () =>
      (config?.[selectedTab] || [])
        .filter((i: any) => i?.selected)
        .map((i: any) => i.pizzaModifierId),
    [config, selectedTab],
  );

  const onCheck = (item: any) => {
    const found = (config?.[selectedTab] || []).findIndex(
      (i: any) => i.pizzaModifierId === item.pizzaModifierId,
    );

    if (found < 0) return;

    flushSync(() => {
      setConfig((e: any) => ({
        ...e,
        [selectedTab]: e[selectedTab].map((entry: any, index: number) =>
          index === found ? { ...entry, selected: !entry.selected } : entry,
        ),
      }));
    });
  };
  return (
    <div className="px-1 py-2 sm:px-2 h-[60vh] overflow-y-auto flex flex-col">
      {options.map((item, index) => (
        <label
          htmlFor={item[label]}
          className="flex gap-3 items-start py-3 px-2 cursor-pointer border-b border-[#e8e3d9] last:border-b-0"
          key={index}
        >
          <Checkbox
            id={item[label]}
            sx={{ p: 0.25, mt: "-2px" }}
            checked={selected.includes(item.pizzaModifierId) || false}
            onChange={() => onCheck(item)}
          />
          <div className="flex-1 min-w-0 flex items-start justify-between gap-3">
            <p className="text-[14px] font-medium text-[#222] leading-5 pr-2">
              {item[label]}
              {Number(item?.defaultTopping) === 1 && (
                <span className="ml-2 inline-flex items-center rounded-full bg-[#f3eee4] px-2 py-[2px] text-[11px] font-semibold leading-none text-[#7b7467]">
                  Default
                </span>
              )}
            </p>
            {!!item.pizzaModifierPrice && (
              <p className="whitespace-nowrap text-[13px] font-semibold text-[#24513e]">
                +${Number(item.pizzaModifierPrice).toFixed(2)}
              </p>
            )}
          </div>
        </label>
      ))}
    </div>
  );
};

export default ModificationSelection;
